// export const BASE_URL = "https://api.lprscsdata.com";
export const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const VERSION_PREFIX = "v1";

export const MAP_API_KEY = "AIzaSyBCqaXRg8wluP0wO1mgynrWPbgS_aBGQ60";
